import { PaymentMethodCreateParams, Stripe } from '@stripe/stripe-js'

interface BillingDetailsInput {
  name?: string
  email?: string
  address?: {
    line1: string
    city: string
    country: string
    postalCode: string
    state?: string | null
  } | null
}

/**
 * Maps our billing details shape to Stripe's `billing_details`,
 * so payment methods carry the address Radar and AVS checks rely on.
 */
export const toStripeBillingDetails = ({
  name,
  email,
  address,
}: BillingDetailsInput): PaymentMethodCreateParams.BillingDetails => ({
  name,
  email,
  ...(address && {
    address: {
      line1: address.line1,
      city: address.city,
      country: address.country,
      postal_code: address.postalCode,
      state: address.state ?? undefined,
    },
  }),
})

export const confirmPendingSetupIntent = async (
  stripe: Stripe,
  intent: string,
  cardId?: string
) => {
  if (intent.startsWith('pi_')) {
    if (!cardId) return await stripe.confirmCardPayment(intent)
    return await stripe.confirmCardPayment(intent, {
      payment_method: cardId,
    })
  } else if (intent.startsWith('seti_')) {
    if (!cardId) return await stripe.confirmCardSetup(intent)
    return await stripe.confirmCardSetup(intent, {
      payment_method: cardId,
    })
  }
}
